module.exports = __webpack_public_path__ + "img/9.f7cd2dbd.svg";